import type { Roller } from './dice.ts';
import type { RollMode } from './rollModes.ts';
import { rollD20 } from './rollModes.ts';
import type { CheckComponent, CheckResult } from './checks.ts';

/**
 * RULE DCC-EVADE-001 - Crawlers & Customization p.14.
 * Evade is an Action, and an Interrupt, used to avoid an incoming attack.
 * Evade is NOT a Skill, so it has no Rank: an Evade Check adds only the Dex Mod.
 *
 * Note the asymmetry with Mobs. A crawler ROLLS to Evade. A Mob does not roll;
 * its Evade is a target number of 10 + Dex Mod + Floor (Rules p.34). That
 * formula belongs to the future GM module and is deliberately not here.
 */
export function evadeModifier(dexMod: number): number {
  return dexMod;
}

export function resolveEvadeCheck(
  roller: Roller,
  dexMod: number,
  mode: RollMode = 'normal',
): CheckResult {
  const die = rollD20(roller, mode);
  const components: CheckComponent[] = [{ label: 'Dex Mod', value: evadeModifier(dexMod) }];

  return {
    kind: 'evade',
    label: 'Evade',
    die,
    components,
    total: die.kept + components.reduce((acc, c) => acc + c.value, 0),
    naturalTwenty: die.kept === 20,
    naturalOne: die.kept === 1,
    untrained: false,
  };
}
